// reactstrap components
import { Container, Row } from "reactstrap";
// core components
import Header from "../../../components/Headers/Header.js";
import UserList from "../../../components/UserList.js";

const UserListing = () => {
  return (
    <>
      <Header
        title="Users"
        description="This is the user list. You can manage the users here."
      />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <UserList />
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UserListing;
